<template>
    <v-data-table dense :headers="headers" :items="itemsData" sort-by="num" hide-default-footer class="propTbl tunedScrollBar" 
                  :items-per-page=-1 fixed-header group-by="groupData">
      <template v-slot:header.name="{ header }">
        {{ $t( 'message.full_custom_title', { cur_ttl: $t(`${header.text}`) } ) }}
      </template>
      <template v-slot:header.val="{ header }">
        {{ $t( 'message.full_custom_title', { cur_ttl: $t(`${header.text}`) } ) }}
      </template>
      <template v-slot:group.header="{ items, isOpen, toggle }">
        <template v-if="items[ 0 ].groupInfo">
          <th @click="toggle">
            <v-icon>{{ isOpen ? 'remove' : 'add' }}</v-icon>
            {{ items[0].groupInfo || items[0].cols[ 0 ] }} 
          </th>
          <th @click="toggle">
            <span>{{ items[ 0 ].cols.length > 1 ? items[0].cols[ 1 ] : '' }}</span>
            <div v-if="getFSshow('ColumnAction')">
              <span v-for="(action, index) in items[ 0 ].groupActions" :key="index" class="prop_toolbuttons">
                <ToolButton ghost :tool-tip="action.toolTip" :icon="action.icon" :title="action.title" v-on:click.stop="action.onClick" :helptoken="action.helptoken"/>
              </span>
            </div>
          </th>
        </template>
      </template>
      <template v-slot:item="{ item }">
        <PropertyItem :item="item" v-bind="item" :featurePrefix="featurePrefix"/>
      </template>
    </v-data-table>
</template>

<script>
import ToolButton from '../ToolButton.vue';
import FeaturesSet from "@/utils/features"
import PropertyItem from "./PropertyItem.vue";

export default {
  name: 'PropertiesSheet',
  props: {
    itemsData: {type: Array, default: undefined},
    featurePrefix: {type:String, default: ""}
  },
  data () {
    return {
      fs: FeaturesSet,
      hasChanges: false,
      headers: [
        { text: 'message.prop_name_col', value: 'name', width: '30%' },
        { text: 'message.prop_value_col', value: 'val' }, 
      ]
    };
  },
  components: {
    ToolButton,
    PropertyItem
  },
  methods: 
  {
    getFSshow(name){
        return this.fs.show(this.featurePrefix?(this.featurePrefix+'.'+name):name);
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .propTbl, .propTbl >>> .v-data-table__wrapper{
      height: 100%;
  }

  .propTbl >>> .v-data-table__wrapper>table>tbody>tr>td{
    padding: 0;
    font-size: 16px;
  }
  .propTbl{
      min-height: 0;
      max-height: 100%;
  }

  /* firefox fix */
  @-moz-document url-prefix() {
    .propTbl >>> .v-data-table__wrapper>table>tbody>tr{
      height: 32px;
    }
    .propTbl >>> .v-data-table__wrapper>table>tbody>tr>td{
      height: 100%;
    }
  }

  .propTbl >>> .prop-number{
    display: inline-flex;
    width: 24px;
    height: calc(100% - 4px);
    border-right: 1px solid #e1e1e1;
    border-radius: 0px;
    align-self: center;
    justify-content: center;
    align-items: center;
  }

  .propTbl >>> .prop_name{
    flex: 1 1;
    align-self: center;
    margin-left: 8px;
  }

  .propTbl >>> .prop_unit{
    color: #777;
    align-self: center;
    font-size: 10px;
    padding-top: 2px;
  }
  .propTbl >>> .prop_unit_selector{
    cursor: pointer;
    user-select: none;
    background-color: #fff;
    border-radius: 6px;
    border: 1px solid #dbdbdb;
    align-self: center;
    display: flex;
    height: 20px;
    padding: 0 0 0 4px;
  }

  .propTbl >>> .prop_type{
    color: #AAA;
    align-self: center;
    font-size: 10px;
  }

  .propTbl >>> .static-value{
    flex: 1 1;
    margin: auto 0;
    padding-left: 8px;
  }

  .propTbl >>> .v-input input{
    min-height: 30px !important;
    height: 100%;
  }

  .propTbl >>> .v-text-field{
    padding-top: 0;
    margin-top: 0;
    height: 100%;
  }
  .propTbl >>> .v-text-field>.v-input__control>.v-input__slot>.v-text-field__slot, .propTbl .v-select__slot {
    padding-left: 8px;
  }

  .propTbl >>> .v-input--switch .v-input--selection-controls__input{
    margin-left:8px;
  }
  .propTbl >>> .v-text-field>.v-input__control, .propTbl >>> .v-input--hide-details>.v-input__control>.v-input__slot{
    height: 100%;
  }
  .propTbl >>> .value-container{
    width:100%; 
    height: 100%; 
    display: flex;
    border-left: 3px solid #dfdfdf;
  }

  .propTbl >>> .editable-value{
    border-left: 3px solid var(--brand-light-color);
  }

  .propTbl >>> tr:hover .editable-value{
    border-left: 3px solid var(--brand-main-color);
  }
  .propTbl >>> .v-input--switch__track.primary--text, 
  .propTbl >>> .v-input--switch__thumb.primary--text, 
  .propTbl >>> .v-input--selection-controls__ripple.primary--text {
    color: var(--brand-main-color) !important;
    caret-color: var(--brand-main-color) !important;
  }

  .propTbl >>> .v-text-field>.v-input__control>.v-input__slot:before{
    /*border: 1px #d8d8d8 solid;*/
    border: none;
  }

  .propTbl >>> .prop_toolbuttons button{
    display: inline-block;
  }
  .propTbl >>> .prop_toolbuttons_left{
    
  }
  .propTbl div table.v-table thead tr
  {
    height: 30px;
  }
  .propTbl >>> .v-data-table__wrapper {
    overflow-x: hidden;
  }
  .propTbl >>> .links-in-text{
    font-size: 10px;
    background-color: #f5f5f5;
    padding: 3px 6px;
    border-radius: 4px;
  }
  .propTbl >>> .require_field .prop_name:after{
    content: ' *';
    color: var(--brand-danger-color);
    font-weight: 800;
  }
  .propTbl >>> .require_value {
    height: 100%;
    border-bottom: 1px solid var(--brand-danger-color);
  }

  .propTbl >>> .deleted_property .prop_name{
    color: #aaa;
  }

  .propTbl >>> .invalid-editor {
    background-color: #fde0e0;
  }

  .propTbl >>> .datetime-editor .v-input input:invalid:not(:focus){
    color: #e0e0e0;
  }

  .propTbl >>> .readonly-editor .v-input--is-disabled, .propTbl >>> .readonly-editor .v-input--is-disabled input {
    color: inherit !important;
  }
  
  .propTbl >>> .saving-state .v-input__control>.v-input__slot:before{
    border: none;
    height: 2px;
    background: linear-gradient(90deg, var(--brand-light-color), var(--brand-light-color), var(--brand-light-color), var(--brand-main-color), var(--brand-light-color), var(--brand-light-color), var(--brand-light-color));
    background-size: 200% 100%;
    animation: gradient 2s ease-in-out infinite;
  }

  .propTbl >>> .v-text-field .v-input__append-inner{
    padding-left: 0 !important;
  }

  .propTbl >>> .v-input--switch.v-input--selection-controls{
    margin-top: 0;
  }
  .propTbl >>>.v-select__selections {
    padding-left: 8px;
  }

  .propTbl >>> .v-data-table__wrapper>table>tbody>tr:last-child td {
    border-bottom: 1px solid #0000001f;
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
</style>
